import React from 'react';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ReviewStars from '../ReviewStars/ReviewStars';

interface ActionsWithReviewsProps {
  buttonText?: string;
  buttonHref?: string;
}

const ActionsWithReviews = ({
  buttonText = 'Start Your Free Trial',
  buttonHref = 'https://cohost.mn.co?plan=free-trial',
}: ActionsWithReviewsProps): JSX.Element => (
  <Stack gap='spacing-3xl'>
    <Stack>
      <Button
        href={buttonHref}
        size='xl'
        variant='primary'
      >
        {buttonText}
      </Button>
    </Stack>
    <Stack hideOn='sm'>
      <ReviewStars />
    </Stack>
  </Stack>
);

export default ActionsWithReviews;
